/**
 * Needed quiz — vlaunch variant.
 */
(function (Q) {
  const { state, depletionScore, IMG, el } = Q.deps();
  const planBenefits = {
    egg_freezing_ivf: [
      '26 essential nutrients at clinical doses',
      'Omega-3 DHA+EPA — 1,000mg per serving',
      'Egg Quality Support (CoQ10 + antioxidants)',
      'Methylated folate (L-5-MTHF) & choline 200mg',
      '3rd-party tested for purity',
    ],
    ttc: [
      '22 essential nutrients at clinical doses',
      'Omega-3 DHA+EPA — 1,000mg per serving',
      'Egg Quality Support complex',
      'Methylated folate (L-5-MTHF) & choline 200mg',
      '3rd-party tested for purity',
    ],
    transfer_prep: [
      '26 essential nutrients at clinical doses',
      'Omega-3 DHA+EPA — 1,000mg per serving',
      'Egg Quality Support complex',
      'Methylated folate (L-5-MTHF) & choline 200mg',
      '3rd-party tested for purity',
    ],
    pregnant: [
      '22 essential nutrients at clinical doses',
      'Separate glycinate-bound iron for better absorption',
      'Omega-3 DHA+EPA — 1,000mg per serving',
      'Methylated folate (L-5-MTHF) & choline 200mg',
      '3rd-party tested for purity',
    ],
    pregnant_pro: [
      '26 nutrients including choline, magnesium, calcium, lutein & zeaxanthin',
      'Separate glycinate-bound iron for better absorption',
      'Omega-3 DHA+EPA — 1,000mg per serving',
      'Clinically studied dosages — IRB-approved',
      '3rd-party tested for purity',
    ],
    postpartum: [
      '22 essential nutrients at clinical doses',
      'Omega-3 DHA+EPA — 1,000mg per serving',
      'Stress Support complex for postpartum recovery',
      'Methylated folate (L-5-MTHF) & choline 200mg',
      '3rd-party tested for purity',
    ],
    multi_only: [
      '22 essential nutrients at clinical doses',
      'Methylated folate (L-5-MTHF) & choline 200mg',
      'Clinically studied dosages',
      '3rd-party tested for purity',
    ],
  };

  function getPlanBenefits(plan) {
    return planBenefits[plan.id] || planBenefits.multi_only;
  }

  function recommendedPlan() {
  const a = state.answers;
  const score = depletionScore();
  const wantsPowder = a.formatPreference === 'powder' || a.formatPreference === 'pills_hard';
  const nausea = a.symptoms.includes('nausea');
  const useFormat = wantsPowder || (nausea && a.formatPreference !== 'capsules_fine') ? 'powder' : 'capsule';

  // egg_freezing post-retrieval → Multi Pro
  if (a.lifestage === 'egg_freezing' && a.stageDetail === 'egg_freezing_post') {
    return {
      id: 'transfer_prep',
      tag: 'For transfer preparation',
      name: 'Prenatal Multivitamin Pro',
      price: '$62.99', cadence: '/ month',
      headline: 'Your transfer window is your preparation window.',
      sub: 'The nutrients you load now become the foundation your embryo implants into.',
      url: 'https://thisisneeded.com/products/prenatal-multivitamin-pro?variant=46099180191989',
      image: IMG.iron_dha_pro,
    };
  }
  // egg_freezing (all other) → Multi Pro
  if (a.lifestage === 'egg_freezing') {
    return {
      id: 'egg_freezing_ivf',
      tag: 'For egg freezing & IVF',
      name: 'Prenatal Multivitamin Pro',
      price: '$62.99', cadence: '/ month',
      headline: 'You have a 90-day window to optimize the eggs you\'ll freeze.',
      sub: 'Egg cell maturation takes 3–4 months. The nutrients you load now are the nutrients those cells use to develop.',
      url: 'https://thisisneeded.com/products/prenatal-multivitamin-pro?variant=46099180191989',
      image: IMG.iron_dha_pro,
    };
  }
  // ttc → Multi 3-cap/powder
  if (a.lifestage === 'ttc') {
    return {
      id: 'ttc',
      tag: 'For trying to conceive',
      name: useFormat === 'powder' ? 'Prenatal Multivitamin Powder' : 'Prenatal Multivitamin',
      price: '$42.99', cadence: '/ month',
      headline: 'Your nutrient stores at conception become your baby\'s foundation.',
      sub: 'Folate, choline, DHA, and antioxidants need to be optimized 90+ days before a positive test.',
      url: useFormat === 'powder' ? 'https://thisisneeded.com/products/prenatal-multi-powder' : 'https://thisisneeded.com/products/prenatal-multi-essentials',
      image: useFormat === 'powder' ? IMG.multi_powder : IMG.multi_capsule,
    };
  }
  // postpartum → Multi 3-cap/powder
  if (a.lifestage === 'postpartum') {
    return {
      id: 'postpartum',
      tag: 'For postpartum & breastfeeding',
      name: useFormat === 'powder' ? 'Prenatal Multivitamin Powder' : 'Prenatal Multivitamin',
      price: '$42.99', cadence: '/ month',
      headline: 'Your body just did the most extraordinary thing. It\'s running on empty.',
      sub: 'Pregnancy and breastfeeding can drain maternal nutrient stores by 30–40%. Replenishment isn\'t a luxury — it\'s recovery.',
      url: useFormat === 'powder' ? 'https://thisisneeded.com/products/prenatal-multi-powder' : 'https://thisisneeded.com/products/prenatal-multi-essentials',
      image: useFormat === 'powder' ? IMG.multi_powder : IMG.multi_capsule,
    };
  }
  // pregnant rx → Multi Pro
  if (a.currentPrenatal === 'rx') {
    return {
      id: 'pregnant_pro',
      tag: 'Clinical-grade upgrade',
      name: 'Prenatal Multivitamin Pro',
      price: '$62.99', cadence: '/ month',
      headline: "You're already used to a clinical standard. Here's what actually meets it.",
      sub: 'Most Rx prenatals are formulated to meet outdated minimums. Multi Pro delivers 26 nutrients at clinically studied doses.',
      url: 'https://thisisneeded.com/products/prenatal-multivitamin-pro?variant=46099180191989',
      image: IMG.iron_dha_pro,
    };
  }
  // pregnant high score + right format → Multi Pro
  if (score >= 8 && (a.formatPreference === 'capsules_fine' || a.formatPreference === 'whatever')) {
    return {
      id: 'pregnant_pro',
      tag: 'High-density formula',
      name: 'Prenatal Multivitamin Pro',
      price: '$62.99', cadence: '/ month',
      headline: "You're sitting in the heart of the depletion problem — let's overcorrect.",
      sub: 'Multi Pro adds Choline, Magnesium, Calcium, Lutein, and Zeaxanthin on top of the 22 nutrients in our core Multi.',
      url: 'https://thisisneeded.com/products/prenatal-multivitamin-pro?variant=46099180191989',
      image: IMG.iron_dha_pro,
    };
  }
  // pregnant (all other) → Multi 3-cap/powder
  return {
    id: 'pregnant',
    tag: 'For pregnancy',
    name: useFormat === 'powder' ? 'Prenatal Multivitamin Powder' : 'Prenatal Multivitamin',
    price: '$42.99', cadence: '/ month',
    headline: nausea
      ? "You shouldn't have to choose between a prenatal that works and one you can actually take."
      : 'Your prenatal is being shortchanged in more ways than one.',
    sub: '12x more nutrition than leading prenatals in 22 nutrients at clinically studied dosages.†',
    url: useFormat === 'powder' ? 'https://thisisneeded.com/products/prenatal-multi-powder' : 'https://thisisneeded.com/products/prenatal-multi-essentials',
    image: useFormat === 'powder' ? IMG.multi_powder : IMG.multi_capsule,
  };
}


  function appendResultMerchandising(card, plan) {
      // ── Add-ons ──
      const addonMap = {
        egg_freezing_ivf: [
          { name: 'CoQ10',             benefit: 'CoQ10 optimizes egg and sperm quality to support fertility. Our form is clinically studied and bioavailable.*', url: 'https://thisisneeded.com/products/coq10',              img: 'https://cdn.shopify.com/s/files/1/0195/3293/9328/files/CoQ10_XXS_Transparent_3c83fc0a-cd48-4516-912e-68150aa62b2e.png?v=1771539551' },
          { name: 'Egg Quality Support', benefit: 'Targeted antioxidants optimize egg quality to support fertility at any age and benefit long-term mitochondrial health.*', url: 'https://thisisneeded.com/products/egg-quality-support', img: 'https://cdn.shopify.com/s/files/1/0195/3293/9328/files/EggQualitySupport_S_Transparent_18c7bece-1daa-409d-ba41-66fbe14460d5.png?v=1771538652' },
        ],
        transfer_prep: [
          { name: 'CoQ10',             benefit: 'CoQ10 optimizes egg and sperm quality to support fertility. Our form is clinically studied and bioavailable.*', url: 'https://thisisneeded.com/products/coq10',              img: 'https://cdn.shopify.com/s/files/1/0195/3293/9328/files/CoQ10_XXS_Transparent_3c83fc0a-cd48-4516-912e-68150aa62b2e.png?v=1771539551' },
          { name: 'Egg Quality Support', benefit: 'Targeted antioxidants optimize egg quality to support fertility at any age and benefit long-term mitochondrial health.*', url: 'https://thisisneeded.com/products/egg-quality-support', img: 'https://cdn.shopify.com/s/files/1/0195/3293/9328/files/EggQualitySupport_S_Transparent_18c7bece-1daa-409d-ba41-66fbe14460d5.png?v=1771538652' },
        ],
        ttc: [
          { name: 'Sperm Support+',    benefit: 'Optimal nutrients, including clinically studied pre/probiotics and Shilajit, support libido and sperm health.*', url: 'https://thisisneeded.com/products/sperm-support', img: 'https://cdn.shopify.com/s/files/1/0195/3293/9328/files/SpermSupport_S_Transparent_c149933a-d733-4e2d-90ea-c50a4d6aea2c.png?v=1771539609' },
          { name: 'Egg Quality Support', benefit: 'Targeted antioxidants optimize egg quality to support fertility at any age and benefit long-term mitochondrial health.*', url: 'https://thisisneeded.com/products/egg-quality-support', img: 'https://cdn.shopify.com/s/files/1/0195/3293/9328/files/EggQualitySupport_S_Transparent_18c7bece-1daa-409d-ba41-66fbe14460d5.png?v=1771538652' },
        ],
        postpartum: [
          { name: 'Cognitive Support', benefit: 'Clinically studied CognatiQ® supports daily cognitive performance with mental clarity and focus.*', url: 'https://thisisneeded.com/products/cognitive-support', img: 'https://cdn.shopify.com/s/files/1/0195/3293/9328/files/Cognitive_Supp_S_JAR_FS_Tr.png?v=1772235407' },
          { name: 'Hydration Support', benefit: 'Electrolytes and trace minerals support hydration, occasional nausea, and breastfeeding without sugar or artificial ingredients.*', url: 'https://thisisneeded.com/products/hydration-support', img: 'https://cdn.shopify.com/s/files/1/0195/3293/9328/files/HydrationSupport_Lemon_StickPack_Transparent.png?v=1771539552' },
        ],
        pregnant_pro: [],
        pregnant:     [],
        multi_only:   [],
      };
        const baseAddons = addonMap[plan.id] || [];
      // For pregnant paths, always add Choline+ and conditionally Iron
      let addons = [...baseAddons];
      if (plan.id === 'pregnant' || plan.id === 'pregnant_pro') {
        addons.push({ name: 'Choline+', benefit: 'Our vegan Choline+ supports baby\'s brain and cognitive development during pregnancy and after birth.*', url: 'https://thisisneeded.com/products/prenatal-choline', img: 'https://cdn.shopify.com/s/files/1/0195/3293/9328/files/pdp_cholinePlus_gallery01.png?v=1771539550' });
        if (state.answers.ironStatus !== 'in_range') {
          addons.push({ name: 'Prenatal Iron', benefit: 'Ferrochel iron has been clinically shown to cause fewer gastrointestinal upsets compared to other forms of iron.*', url: 'https://thisisneeded.com/products/prenatal-iron', img: 'https://cdn.shopify.com/s/files/1/0195/3293/9328/files/Iron_XXS_ALT_Transparent_03a93a9b-f8b6-4977-83e3-152335093968.png?v=1771539610' });
        }
      }

      // Add-on tiles with thumbnail + Add to Cart
      if (addons.length > 0) {
        const addonsSection = el('div', { class: 'result-addons' });
        addonsSection.appendChild(el('div', { class: 'result-addons-label' }, 'Recommended Add-ons'));
        addons.forEach(ad => {
          const tile = el('div', { class: 'result-addon-tile' });
          const imgEl = el('img', { src: ad.img, alt: ad.name, class: 'result-addon-img', loading: 'eager' });
          imgEl.onerror = () => { imgEl.style.display = 'none'; };
          tile.appendChild(imgEl);
          const meta = el('div', { class: 'result-addon-meta' });
          meta.appendChild(el('div', { class: 'result-addon-name' }, ad.name));
          meta.appendChild(el('div', { class: 'result-addon-benefit' }, ad.benefit));
          tile.appendChild(meta);
          tile.appendChild(NeededQuizCart.createButton({ className: 'btn result-addon-btn', text: 'Add to Cart →', url: ad.url }));
          addonsSection.appendChild(tile);
        });
        card.appendChild(addonsSection);
      }

      // Bundle upsell
      const bundleMap = {
        egg_freezing_ivf: { name: 'Egg Freezing & IVF Support Plan', price: '$156', url: 'https://thisisneeded.com/products/egg-freezing-ivf-support-plan', image: IMG.egg_freezing },
        transfer_prep:    { name: "Women's Fertility Support Plan",   price: '$111', url: 'https://thisisneeded.com/products/fertility-support-plan',          image: IMG.ttc },
        ttc:              { name: "Women's Fertility Support Plan",   price: '$111', url: 'https://thisisneeded.com/products/fertility-support-plan',          image: IMG.ttc },
        postpartum:       { name: 'Postnatal Vitamins Plan',          price: '$111', url: 'https://thisisneeded.com/products/postnatal-vitamins-plan',         image: IMG.postnatal },
        pregnant_pro:     { name: 'Complete Prenatal Pro Plan',       price: '$85',  url: 'https://thisisneeded.com/products/prenatal-vitamins-iron-dha-pro',  image: IMG.iron_dha_pro },
        pregnant:         { name: 'Prenatal Vitamins with Iron + DHA', price: '$85', url: 'https://thisisneeded.com/products/prenatal-vitamins-iron-dha',      image: IMG.iron_dha },
      };
      const bundleInfo = bundleMap[plan.id];
      if (bundleInfo) {
        const bundle = el('div', { class: 'result-bundle-upsell' });
        if (bundleInfo.image) {
          const bImgCard = el('div', { class: 'result-bundle-img-card' });
          const bImg = el('img', { src: bundleInfo.image, alt: bundleInfo.name, loading: 'eager', class: 'result-bundle-img' });
          bImg.onerror = () => { bImgCard.style.display = 'none'; };
          bImgCard.appendChild(bImg);
          bundle.appendChild(bImgCard);
        }
        bundle.appendChild(el('div', { class: 'result-bundle-heading' }, 'Looking for more support?'));
        const bundleDesc = el('p', { class: 'result-bundle-desc' });
        bundleDesc.innerHTML = 'Get everything in one plan: <strong>' + bundleInfo.name + '</strong> · From <strong>' + bundleInfo.price + '</strong>/month';
        bundle.appendChild(bundleDesc);
        bundle.appendChild(NeededQuizCart.createButton({ className: 'btn result-bundle-btn', text: 'Add Plan to Cart →', url: bundleInfo.url }));
        card.appendChild(bundle);
      }
  }

  if (!Q) {
    console.error('[needed-quiz] Load needed-quiz-core.js before needed-quiz-vlaunch.js');
    return;
  }

  Q.register({ recommendedPlan, getPlanBenefits, appendResultMerchandising });
})(window.NeededQuizCore);
